import { useContext } from 'react';
import { useQuery } from 'react-query';

import { getCompanyInfo } from 'api/companyService';
import { getCompanyTaxId } from 'api/taxIdService';

import { FeatureContext } from '../../components/AccessResolvers/featureContext';

export const useGetCompanyInfo = () => {
  const {
    featureState: { authV3Enabled },
  } = useContext(FeatureContext);

  return useQuery('companyInfo', () => getCompanyInfo(authV3Enabled));
};

export const useGetCompanyTaxId = () => {
  const {
    featureState: { accountInfoTaxID },
  } = useContext(FeatureContext);

  return useQuery('companyTaxId', getCompanyTaxId, {
    enabled: accountInfoTaxID,
    retry: false,
  });
};
